import React from 'react';

import { cn } from 'src/utils/shadcn';

import type { GeneralAxiosError } from 'src/registry/types/axios';

interface FormErrorBlockProps<TData, TError extends GeneralAxiosError<TData>>
    extends React.HTMLAttributes<HTMLParagraphElement> {
    error: TError | null;
}

export default function FormErrorBlock<TData, TError extends GeneralAxiosError<TData> = GeneralAxiosError<TData>>({
    error,
    className,
}: FormErrorBlockProps<TData, TError>) {
    if (error?.response && error.response.data.detail) {
        return <p className={cn('h-4 text-sm text-red-500', className)}>{error.response.data.detail}</p>;
    }
    if (error?.message) {
        return <p className={cn('h-4 text-sm text-red-500', className)}>{error.message}</p>;
    }
}
